import React  from 'react'
import ContactForm from './ContactForm'
import './Sections.css'

const Sections = () => {
  return (
    <>
      <section aria-hidden="true"/>
      <section aria-hidden="true"/>
      <section className='projects' id="projects">
        <h2>At Signal Theory, we craft dimensional experiences that are intuitive by design and delightful by nature.</h2>
      </section>
      <section aria-hidden="true"/>
      <section aria-hidden="true"/>
      <section aria-hidden="true"/>
      <section aria-hidden="true"/>
      <section aria-hidden="true"/>
      <section id="contact" className="section contact">
        <div className='container'>
          <div className='content'>
            <h3 id="contact-heading">Ready to send a stronger signal? Let's talk.</h3>
          </div>
          <div className='form'>
            <ContactForm />
            <p>View more of what we do at <a href="https://signaltheory.com" target="_blank" rel="noopener noreferrer">signaltheory.com</a></p>
          </div>
        </div>
      </section>
      
      
      {/* ARIA announcer */}
      <div aria-live="polite" className="sr-only" />
    </>
  )
}

export default Sections
